import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { ServiceApprovalDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';

import { ServiceApprovalDto } from 'src/app/shared/models/service-approval/service-approval-dto.model';
import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ServiceApprovalWorkItem extends WorkItem<ServiceApprovalDto> {
  constructor(@Inject(UnitOfWorkFactory) _unitOfWorkFactory: IUnitOfWorkFactory) {
    super(_unitOfWorkFactory);
  }

  get name(): string {
    return 'ServiceApprovalWorkItem';
  }
  get database(): string {
    return ServiceApprovalDB;
  }
}
